import Dividers, { DividersProps } from './Dividers';

export type { DividersProps };
export default Dividers;
